import React, { useState } from 'react';
import './WaterPickerModal.css';

/**
 * Quick hydration logger. Tap a container to log one of that container to the
 * meal in a single click. Each container has its own backing food doc (e.g.
 * `_water_glass`) so the meal list shows "Glass of water" rather than a
 * generic millilitre count, and stacking 2 cans + 2 glasses stays distinct.
 *
 * The custom-volume input falls back to the generic `_water` food in ml.
 */
const CONTAINERS = [
    { id: 'sip',      label: 'Sip',           emoji: '🥃', volume: 100,  food_id: '_water_sip' },
    { id: 'glass',    label: 'Glass',         emoji: '🥛', volume: 250,  food_id: '_water_glass' },
    { id: 'mug',      label: 'Mug',           emoji: '☕', volume: 300,  food_id: '_water_mug' },
    { id: 'can',      label: 'Can',           emoji: '🥤', volume: 330,  food_id: '_water_can' },
    { id: 'bottle_s', label: 'Small bottle',  emoji: '🍶', volume: 500,  food_id: '_water_bottle_s' },
    { id: 'bottle_l', label: 'Large bottle',  emoji: '🍾', volume: 750,  food_id: '_water_bottle_l' },
    { id: 'liter',    label: '1 liter',       emoji: '💧', volume: 1000, food_id: '_water_liter' }
];

const WaterPickerModal = ({ close, onSelect }) => {
    const [customMl, setCustomMl] = useState('');

    const pickContainer = (container) => {
        // One serving of the container's own food doc.
        onSelect({ food_id: container.food_id, quantity: 1, unit: 'serving' });
        close();
    };

    const submitCustom = (e) => {
        e.preventDefault();
        const v = parseInt(customMl, 10);
        if (!Number.isFinite(v) || v <= 0) return;
        onSelect({ food_id: '_water', quantity: v, unit: 'ml' });
        close();
    };

    return (
        <div className="water-picker-modal">
            <div className="wpm-header">
                <span className="wpm-title-emoji">💧</span>
                <h3>Log Water</h3>
                <p className="wpm-subtitle">Tap a container to log it instantly</p>
            </div>

            <div className="wpm-grid">
                {CONTAINERS.map((c) => (
                    <button
                        key={c.id}
                        className="wpm-container"
                        onClick={() => pickContainer(c)}
                        title={`${c.label} — ${c.volume} ml`}
                    >
                        <span className="wpm-container-emoji">{c.emoji}</span>
                        <span className="wpm-container-label">{c.label}</span>
                        <span className="wpm-container-volume">{c.volume} ml</span>
                    </button>
                ))}
            </div>

            <form className="wpm-custom" onSubmit={submitCustom}>
                <span className="wpm-custom-emoji">✏️</span>
                <input
                    type="number"
                    inputMode="numeric"
                    min="1"
                    step="10"
                    placeholder="Custom volume (ml)"
                    value={customMl}
                    onChange={(e) => setCustomMl(e.target.value)}
                />
                <button type="submit" className="wpm-custom-add" disabled={!customMl}>
                    Add
                </button>
            </form>
        </div>
    );
};

export default WaterPickerModal;
